import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  user: icon('ic-user'),
  menuItem: icon('ic-menu-item'),
  store: icon('ic-banking'),
};

// ----------------------------------------------------------------------

export const insightsNavData = [
  /**
   * Overview
   */
  {
    subheader: 'Insights',
    items: [
      {
        title: 'Summary',
        path: paths.insights.root,
        icon: ICONS.analytics,
      },
      {
        title: 'Stores',
        path: paths.insights.stores.root,
        icon: ICONS.store,
        children: [
          {
            title: 'Overview',
            path: paths.insights.stores.root,
          },
        ],
      },
      {
        title: 'Products',
        path: paths.insights.products.root,
        icon: ICONS.ecommerce,
        children: [
          {
            title: 'Summary',
            path: paths.insights.products.root,
          },
          {
            title: 'Co-Occurrence',
            path: paths.insights.products.coOccurrence,
          },
        ],
      },
      {
        title: 'Categories',
        path: paths.insights.categories.root,
        icon: ICONS.menuItem,
      },
      {
        title: 'Customers',
        path: paths.insights.customers.root,
        icon: ICONS.user,
        children: [
          {
            title: 'Customer Trends',
            path: paths.insights.customers.root,
          },
          {
            title: 'Repeat Rates',
            path: paths.insights.customers.repeatRates,
          },
          {
            title: 'Traffic Summary',
            path: paths.insights.customers.trafficSummary,
          },
          {
            title: 'Active Users',
            path: paths.insights.customers.activeUsers,
          },
          {
            title: 'Average Monthly Frequency',
            path: paths.insights.customers.avgMonthlyFrequency,
          },
          {
            title: 'Repeat Customers Within X Days',
            path: paths.insights.customers.repeatCustomersWithinXDays,
          },
          {
            title: 'Average LTV',
            path: paths.insights.customers.averageLTV,
          },
          {
            title: 'Promo Signup Stats',
            path: paths.insights.customers.promoSignUpStats,
          },
        ],
      },
      {
        title: 'Promotions',
        path: paths.insights.promotions.root,
        icon: <Iconify icon="solar:gift-bold-duotone" />,
        children: [
          {
            title: 'Summary',
            path: paths.insights.promotions.root,
          },
        ],
      },
    ],
  },
];
